import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";

const SwiperGiftCard = ({
  type,
  ind,
  list,
  swiperValue,
  setswiperValue,
}: any) => {
  return (
    <>
      <div className="slider-gift-main">
        <Swiper
          slidesPerView={5}
          watchSlidesProgress={true}
          navigation={{
            nextEl: ".arrow-right" + ind + type,
            prevEl: ".arrow-left" + ind + type,
          }}
          autoHeight={true}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
        >
          {!!list?.length &&
            list?.map((v: any, k: any) => (
              <SwiperSlide key={k}>
                <div
                  onClick={() => {
                    setswiperValue({ value: k, index: ind, type: type });
                  }}
                  style={{ height: 100 }}
                  className={
                    swiperValue === k ? "swiper-gift active" : "swiper-gift "
                  }
                >
                  <Image src={v} alt="" layout="fill" unoptimized />
                </div>{" "}
              </SwiperSlide>
            ))}{" "}
        </Swiper>
        <>
          <button
            type="button"
            className={
              list?.length <= 5
                ? "d-none"
                : "" + ` arrow-left${ind + type}` + " arrow arrow-next"
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#ff1932"
              viewBox="0 0 16 16"
            >
              <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
            </svg>
          </button>
          <button
            type="button"
            className={
              list?.length <= 5
                ? "d-none"
                : "" + ` arrow-right${ind + type}` + " arrow arrow-prv"
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#ff1932"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
            </svg>
          </button>
        </>
      </div>
    </>
  );
};

export default SwiperGiftCard;
